import { Vertical, Texto, MaterialIcon, Horizontal } from '@gravitate-js/excalibrr'
import { formatters } from '@utils/intl/dateTimeFormatters'
import type { MatchDetailResponse } from '@/api/useSupplierReconciliation/useMatchDetail'
import dayjs from 'dayjs'
interface OnHoldInfoPopoverProps {
  data: MatchDetailResponse
}

export function OnHoldInfoPopover({ data }: OnHoldInfoPopoverProps) {
  const { hold_date, hold_reason, assignee, hold_by } = data ?? {}
  const displayName = hold_by ?? assignee?.username ?? 'Unknown User'
  const timezone = data?.bol_date_local ?? data?.timezone_data?.terminal ?? dayjs.tz.guess()
  const formattedDate = hold_date ? formatters.WEEKDAY_MONTH_DATE_TIME(hold_date, timezone) : 'Date unknown'

  return (
    <div style={{ minWidth: 300 }}>
      <Horizontal style={{ marginBottom: 8 }}>
        <Vertical flex={2} gap='4px'>
          <Texto category='label' weight='600' style={{ color: 'var(--theme-warning)' }}>
            Marked On Hold By
          </Texto>
          <Horizontal alignItems='center'>
            <MaterialIcon icon='person' style={{ color: 'var(--theme-text-secondary)', fontSize: 16 }} />
            <Texto category='p1' style={{ paddingLeft: 8 }}>
              {displayName}
            </Texto>
          </Horizontal>
        </Vertical>
        <Vertical style={{ overflow: 'visible' }} gap='4px' flex={1} alignItems='flex-end'>
          <Texto category='label' weight='600' style={{ color: 'var(--theme-warning)' }}>
            At
          </Texto>
          <Texto style={{ whiteSpace: 'nowrap' }} category='p1'>
            {formattedDate}
          </Texto>
        </Vertical>
      </Horizontal>
      <Horizontal>
        <Vertical gap='4px' flex={1} style={{ overflow: 'visible' }}>
          <Texto category='label' weight='600' style={{ color: 'var(--theme-warning)' }}>
            Reason
          </Texto>
          <Texto
            category='p1'
            style={{ lineHeight: 1.4, wordBreak: 'break-word', fontStyle: !hold_reason ? 'italic' : 'normal' }}
          >
            {hold_reason ?? 'No reason provided'}
          </Texto>
        </Vertical>
      </Horizontal>
    </div>
  )
}
